import { hotelStatusNames, hotelSubsidiaryPmsHealthyKinds } from 'main/hotelStatuses'

/**
 *
 * @typedef Hotel
 * @property {string} hotelName
 * @property {string} bookingEngine
 * @property {string} chainCode
 * @property {string} parentChainCode
 * @property {string} textMarketingUrlKey
 * @property {string} addedOn
 * @property {number} addedBy
 * @property {string} updatedOn
 * @property {number} updatedBy
 * @property {string} id
 * @property {number} numberOfRooms
 * @property {string} pms
 * @property {boolean} isMissingSomeInformation
 * @property {number} displayId
 * @property {boolean} isDeleted
 * @property {string} status
 * @property {object[]} subsidiaryPmsUsers
 * @property {number} subsidiaryPmsUsers.id
 * @property {string} subsidiaryPmsUsers.subsidiaryId
 * @property {string} subsidiaryPmsUsers.email
 * @property {string} subsidiaryPmsUsers.firstName
 * @property {string} subsidiaryPmsUsers.lastName
 * @property {string} subsidiaryPmsUsers.birthDate
 * @property {string} subsidiaryPmsUsers.addedOn
 * @property {number} subsidiaryPmsUsers.addedBy
 * @property {string} merchantName
 * @property {boolean} inviteBackIsDisabled
 * @property {object[]} inviteBlockOn
 * @property {string} inviteBlockOn.addedBy
 * @property {string} inviteBlockOn.addedOn
 * @property {string} inviteBlockOn.reason
 * @property {boolean} pmsSyncIsConnected
 * @property {boolean} isServiceStarted
 * @property {boolean} isCampaignsEnabled
 * @property {boolean} isTcrActivated
 * @property {boolean} isPhoneEnabled
 * @property {object[]} tags
 * @property {number} tags.id
 * @property {string} tags.name
 * @property {string} tags.addedBy
 * @property {string} tags.addedOn
 * @property {string} processKind
 *
 *
 */

/**
 * @param {Hotel} hotel
 * @returns {string}
 */
export function getStatusText(hotel) {
  return hotelStatusNames[hotel.status]
}

/**
 * @param {Hotel} hotel
 * @returns {string}
 */
export function getIssueText(hotel) {
  if (!hotel.isTcrActivated) {
    return 'TCR deactivated'
  } else if (!hotel.isPhoneEnabled) {
    return 'Problem with phone'
  } else if (!hotel.isEnabledPlatformAccessFee) {
    return 'Platform access fee is not enabled'
  } else if (!hotel.pmsSyncIsConnected) {
    return hotelSubsidiaryPmsHealthyKinds[hotel.pmsHealthyKind]
  } else if (hotel.inviteBlockOn) {
    return 'AutoInvite disabled'
  } else if (!hotel.isCampaignsEnabled) {
    return 'Campaigns are not enabled'
  } else if (!hotel.isServiceStarted) {
    return 'Services has not started'
  }

  return 'Up and Running'
}

/**
 *
 * @param {Hotel} hotel
 * @returns {string}
 */
export function getBrokenCtaText(hotel) {
  switch (hotel.status) {
    case 'PendingCampaignBrandRegistration':
      return 'Add tax info'
    case 'PendingPhoneNumberSetup':
      return 'Set up telecom'

    default:
      return 'View & fix'
  }
}
